export default __webpack_public_path__ + "static/media/rocket_anim_116.6cd7d5aa.png";